import { BASE_URL } from "api_urls";
import type { AdyenFormState } from "types/payments/adyen/AdyenWebSDK";
import type { INewCreditCardAdyen } from "types/reducers/payment";
import type { IOrderPayload } from "types/totals";

export interface IAdyenOrderPayload extends IOrderPayload {
  browserInfo: AdyenFormState["data"]["browserInfo"];
  paymentMethod: AdyenFormState["data"]["paymentMethod"];
  returnUrl: string;
  billingAddress: {
    firstName: string;
    lastName: string;
    city: string;
    country: string;
    houseNumberOrName: string;
    postalCode: string;
    stateOrProvince: string;
    street: string;
  };
}

export function adyenTransformPayload(
  payload: IOrderPayload,
  card: INewCreditCardAdyen
): IAdyenOrderPayload {
  const { browserInfo, paymentMethod } = card.ccData.data;
  return {
    ...payload,
    browserInfo,
    paymentMethod,
    returnUrl: `${BASE_URL}/s/${payload.storePrettyUrl}/?callback=adyen`,
    billingAddress: {
      firstName: card.firstName,
      lastName: card.lastName,
      city: card.city,
      country: "US",
      houseNumberOrName: card.address2,
      street: card.address1,
      postalCode: card.zip,
      stateOrProvince: card.state,
    },
  };
}
